import React, { Fragment } from 'react';

import * as Actions from 'cost_centers/components/list/actions';

const CostCentersActions = ({ permissions, costCenter, company, subcompany, handleToggle }) => {
  return (
    <Fragment>
      {permissions['acl.cost_centers.toggle'] && (
        <Actions.Toggle costCenter={costCenter} handleClick={handleToggle} />
      )}
      {permissions['acl.cost_centers.update'] && (
        <Actions.Edit costCenter={costCenter} company={company} subcompany={subcompany} />
      )}
    </Fragment>
  );
};

export default CostCentersActions;



// WEBPACK FOOTER //
// src/modules/secured/modules/cost_centers/components/list/CostCentersActions.js